// src/services/contactService.js
import api from './api';

// Normalize backend responses (array OR wrapped object)
const ensureArray = (res) => {
  const data = res?.data;

  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.contacts)) return data.contacts;
  if (data && Array.isArray(data.data)) return data.data;
  if (data && Array.isArray(data.results)) return data.results;

  return [];
};

export const contactService = {
  // public form
  submit: (payload) => api.post('/contact', payload).then((res) => res.data),

  // admin inbox
  getAll: () => api.get('/contact').then((res) => ensureArray(res)),

  // admin update: mark read/unread etc.
  updateStatus: (id, payload) => api.put(`/contact/${id}`, payload).then((res) => res.data),

  // admin delete
  delete: (id) => api.delete(`/contact/${id}`).then((res) => res.data),

  // optional helpers (if you use)
  getStats: () => api.get('/contact/stats').then((res) => res.data),
  bulkUpdate: (payload) => api.put('/contact/bulk', payload).then((res) => res.data),
  bulkDelete: (payload) => api.delete('/contact/bulk', { data: payload }).then((res) => res.data),
};
